import React from 'react';
import { withStyles } from '@material-ui/core/styles';
// MaterialUI Components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Divider from '@material-ui/core/Divider';

const styles = {
  summary: {
    paddingLeft: 5,
  },
  summaryContent: {
    alignItems: 'center',
    marginTop: '5px !important',
    marginBottom: '5px !important',
    marginLeft: '5px !important',
  },
  actionButtons: {
    paddingTop: 5,
    paddingBottom: 5,
  },
  content: {
    flexDirection: 'column',
    paddingBottom: 10,
  },
  title: {
    marginLeft: 4,
  },
};

const RuleAssignmentPanel = props => {
  const {
    onClick,
    classes,
    dataTestIds,
    title,
    secondaryAction,
    isOpen,
    description,
    collapseContent,
    buttons,
  } = props;

  return (
    <ExpansionPanel
      data-test-id={dataTestIds.root}
      className={classes.root}
      expanded={isOpen}
    >
      <ExpansionPanelSummary
        onClick={onClick}
        expandIcon={<ExpandMoreIcon data-test-id={dataTestIds.listIcon} />}
        className={classes.summary}
        classes={{
          content: classes.summaryContent,
        }}
      >
        {secondaryAction}
        <Typography
          data-test-id={dataTestIds.title}
          variant="h6"
          className={classes.title}
        >
          {title}
        </Typography>
      </ExpansionPanelSummary>
      <Divider />
      <ExpansionPanelDetails className={classes.content}>
        <Typography variant="subtitle1" data-test-id={dataTestIds.description}>
          {description}
        </Typography>
        {collapseContent}
      </ExpansionPanelDetails>
      <Divider />
      <ExpansionPanelActions className={classes.actionButtons}>
        {buttons.map(({ title, onClick, dataTestId, className }) => (
          <Button
            onClick={onClick}
            data-test-id={dataTestId}
            key={title}
            className={className}
          >
            {title}
          </Button>
        ))}
      </ExpansionPanelActions>
    </ExpansionPanel>
  );
};

export default withStyles(styles)(RuleAssignmentPanel);
